import saveShareCartQuery from '@tcp/core/src/queries/saveShareCart.query.graphql';
import getShareCartQuery from '@tcp/core/src/queries/getShareCart.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler/handler';
import { graphQlErrorHandler } from '../../../utils/errorMessage.util';

export const saveShareCart = (emailId, isBackPack, errorsMapping) => {
  return executeStatefulGraphQLQuery({
    query: saveShareCartQuery,
    variables: { emailId, isBackPack },
    type: 'mutation',
  })
    .then((res) => {
      if (res.errors) {
        const err = res.errors;
        throw graphQlErrorHandler(err, errorsMapping);
      }
      return res.data && res.data.saveShareCart;
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorsMapping);
    });
};

export const fetchShareCart = (requestId, errorsMapping) => {
  return executeStatefulGraphQLQuery({
    query: getShareCartQuery,
    variables: { requestId },
    type: 'mutation',
  })
    .then((res) => {
      if (res.errors) {
        const err = res.errors;
        throw graphQlErrorHandler(err, errorsMapping);
      }
      return res.data && res.data.shareCart;
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorsMapping);
    });
};
